import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['field'];

  connect() {
  }

  fetch(e) {
    const data = {
      email: e.target.value
    };

    this.fieldTargets.forEach(field => {
      data[field.name] = field.value;
    });

    // Use global Rails from vendor.js
    window.Rails.ajax({
      url: this.data.get('url'),
      type: 'get',
      data: new URLSearchParams(data).toString(),
    });
    e.preventDefault();
  }
}
